// 注册
import request from '@/utils/request'

/**
 * 查询个人报价回显(已报价)
 * @param {*} data 
 * @returns 
 */
export function personalQuotation(data) {
    return request({
        url: '/front/personalCenter/personalQuotation',
        method: 'post',
        data
    })
}


/**
 * 根据类型查询个人车辆相关信息
 */
export function findCarInfoByType(data) {
    return request({
        url: '/front/personalCenter/findCarInfoByType',
        method: 'POST',
        data
    })
}


/**
 * 查询配置信息
 * 收获说明：publicAccountInformation
    竞价规则：biddingRules
    公司简介：companyProfile
    网点说明：dotInformation
    争议解释：disputeExplanation
    法律声明：legalStatement
    注意事项：notice
    隐私政策：privacyPolicy
    资质证明：qualificationProof
    服务协议：serviceAgreement
    系统设置：systemSettings
 */
export function getConfigInfo(params) {
    return request({
        url: '/front/sysconfig',
        method: 'GET',
        params
    })
}


/**
 * 获取服务器时间
 */
export function getServerTime() {
    return request({
        url: '/front/sysconfig/system-time',
        method: 'GET'
    })
}